import {
  Directive,
  Input,
  HostListener,
  Inject
} from '@angular/core';
import { StatisticService } from '@iv/shared/statistic.service';
import { getCurrentTab } from '@iv/store/tabs/tabs.selectors';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';

@Directive({
  selector: '[statistic]',
})
export class StatisticDirective {

  _statisticElementName: string;

  @Input() set statisticElementName(value: string) {
    this._statisticElementName = value;
  }

  public constructor(
    private statisticService: StatisticService,
    @Inject(AppStore) private store: Redux.Store<AppState>
  ) {
  }

  @HostListener('click', ['$event'])
  private onClick(event) {
    const state = this.store.getState();
    const currentTab = getCurrentTab(state);
    let buttonName;
    if (currentTab && currentTab.component) {
       buttonName = `${this._statisticElementName}, component=${currentTab.component}`;
    } else {
      buttonName = `${this._statisticElementName}`;
    }
    this.statisticService.incrementClickButton(buttonName);
  }

}
